import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import Styles from "./status-box.less"
import jss from "jss"
import withSkin from "@cirrus/legacy/app-common/alt/framework/withSkin.jsx"
import v from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"
import { toJss, darken } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"

const defaultTypes = [
  "default",
  "undefined",
  "notstarted",
  "archived",
  "notsubmitted",
  "nothandedin",
  "na",
  "withdrawn",
  "NOT_STARTED",
]
const infoTypes = [
  "info",
  "handedin",
  "moderationhandedin",
  "readyforreview",
  "ongoing",
  "readyforassessing",
  "moderationnotneeded",
  "ONGOING",
]
const successTypes = [
  "success",
  "live",
  "approved",
  "active",
  "passed",
  "assessed",
  "moderationassessingcomplete",
  "satisfactory",
  "moderationneeded",
  "assessingcomplete",
  "scoringcomplete",
  "moderationcomplete",
  "moderationscoringcomplete",
  "ok",
  "FINISHED",
]
const warningTypes = [
  "warning",
  "draft",
  "paused",
  "pending",
  "assessinginprogress",
  "scoringinprogress",
  "moderationscoringinprogress",
  "waitingforcoassessor",
  "inprogress",
  "assessing",
  "waitingformoderator",
]

const newWarningTypes = ["new_inprogress"]

const errorTypes = ["error", "notapproved", "void", "failed", "notsatisfactory", "voided"]
const disabledTypes = ["removed"]

class StatusBox extends C {
  static dynamicStyles = null
  static displayName = "StatusBox"

  static propTypes = {
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    isFeedback: PropTypes.boolean,
  }

  constructor(props) {
    super(props)
    if (StatusBox.dynamicStyles == null) {
      const dynamicStylesConfig = toJss(props.skinObject.statusBox || {}, {
        default: {
          color: v.gray920,
        },
        info: {
          color: v.blue305,
        },
        closed: {
          color: v.gray305,
        },
        success: {
          color: v.green300,
        },
        inprogress: {
          color: v.yellow,
        },
        warning: {
          color: v.orange550,
        },
        error: {
          color: v.red550,
        },
        disabled: {
          color: v.gray215,
        },
        new_closed: {
          color: v.gray305,
        },
        new_error: {
          color: v.red905,
        },
        new_inprogress: {
          color: v.yellowinprogress,
        },
        new_invalid: {
          color: v.blackt30,
        },
        new_success: {
          color: v.green300,
        },
      })

      StatusBox.dynamicStyles = jss.createStyleSheet(dynamicStylesConfig).attach()
    }
  }

  getTypeClass() {
    let { classes } = StatusBox.dynamicStyles

    let isType = (types) => types.indexOf(this.props.type) !== -1
    if (this.props.isFeedback) return classes[`new_${this.props.type}`]

    switch (true) {
      case isType(defaultTypes):
        return classes.default
      case isType(infoTypes):
        return classes.info
      case isType(successTypes):
        return classes.success
      case isType(warningTypes):
        return classes.warning
      case isType(errorTypes):
        return classes.error
      case isType(disabledTypes):
        return classes.disabled
      case isType(newWarningTypes):
        return classes.new_inprogress
      default:
        return undefined
    }
  }

  getClass() {
    return classNames(this.props.className, Styles.statusBox, this.getTypeClass())
  }

  render() {
    return (
      <span className={this.getClass()} onClick={this.props.onClick}>
        {this.props.text}
      </span>
    )
  }
}
export default withSkin(StatusBox)
